import React from 'react';
import './App.css';
import Login from './components/login/Login';
import ForgotPassword from './components/login/ForgotPassword';
import ResetPassword from './components/login/ResetPassword';
import AdminPage from './components/AdminPage';
import RetirosAdminPage from './components/RetirosAdminPage';
import WaiterPage from './components/WaiterPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './utils/ProtectedRoute';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Router>
      <Toaster
        position="top-right"
        gutter={8}
        toastOptions={{
          // Defaults globales (los wrappers en utils/toast.js sobrescriben por tipo)
          style: {
            background: '#17171d',
            color: '#f5f5f7',
            border: '1px solid #26262e',
            borderRadius: '12px',
            padding: '12px 14px',
            fontSize: '14px',
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={['restaurante']}>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/waiter"
          element={
            <ProtectedRoute allowedRoles={['empleado']}>
              <WaiterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/RetirosAdminPage"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <RetirosAdminPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
